<template>
  <div class="detail-tab">
    <van-tabs color="#00476C" line-width="20px" line-height="4px" title-active-color="#00476C"
              title-inactive-color="#666666" v-model="active">
      <van-tab :disabled="tab2" title="直播"/>
      <van-tab v-if="data === '0' && videoList > 0" :disabled="tab1" title="回放"/>
    </van-tabs>
    <div class="xian">
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detailTab",
  props: {
    videoList: {
      type: Number,
      default: 0
    },
    data: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: 3,
      tab1: false,
      tab2: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.data === '0' && this.videoList < 1) {
        this.active = 0
        this.tab1 = true
      } else {
        this.active = 1
        this.tab2 = true
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.detail-tab {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px 25px;
  position: relative;

  .xian {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 25px;
    width: 100%;
    position: absolute;
    bottom: 14px;
    left: 0;

    div {
      height: 1px;
      background: #ECECEC;
    }
  }
}

::v-deep {
  .van-tab__text {
    font-size: 16px;
  }
}
</style>
